export const EntityType = {
  COMMENT_OF_USER: "COMMENT_OF_USER",
};

export const QueryKeys = {
  commentOfUser: () => [EntityType.COMMENT_OF_USER, "LIST"],
};
